import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Circles } from 'react-loader-spinner';

const TechnologyBrowseModal = ({ show, onClose, onApply, options, selected, setSelected, search, setSearch, loadingTechnologies }) => {

    const handleToggle = (option) => {
        if (selected.includes(option)) {
            setSelected(selected.filter((item) => item !== option));
        } else {
            setSelected([...selected, option]);
        }
    };

    const handleApply = () => {
        if (selected.length === 0) {
            setSearch('');
        }
        onApply();
    };

    return (
        <Modal show={show} onHide={onClose} centered className="contact-level-modal">
            <Modal.Header closeButton>
                <Modal.Title>Technologies</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Typeahead
                    flip={true}
                    id="search-technology"
                    multiple={false}
                    onInputChange={setSearch}
                    selected={[]}
                    placeholder="Search technologies..."
                    options={[]}
                    open={false}
                />

                {loadingTechnologies ? (
                    <div className="d-flex justify-content-center align-items-center py-4">
                        <Circles
                            height="30"
                            width="30"
                            color="#007bff"
                            ariaLabel="circles-loading"
                            visible={true}
                        />
                    </div>
                ) : (
                    <div className="p-2" >
                        {options && options.map((option) => (
                            <Form.Check
                                key={option.value}
                                type="checkbox"
                                label={option.label}
                                id={`checkbox-${option.value}`}
                                checked={selected.includes(option.label)}
                                onChange={() => handleToggle(option.label)}
                                className="mb-2"
                            />
                        ))}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleApply}>
                    Apply
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TechnologyBrowseModal;
